import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";

const JOB_STATUS_ENDPOINT = "/jobs/processing";

export default function useProcessingJobs() {
  const api = useAxios();
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["processingJobs"],
    queryFn: () => api.get(JOB_STATUS_ENDPOINT),
    enabled: false,
  });

  handleError(error);

  const jobs = data?.data ?? [];

  return { jobs, isLoading, getJobs: refetch };
}
